<template>
  <div>
      Einen Moment bitte...
  </div>
</template>

<script>
import router from '../../router'

export default {
  props: {
    to_name: {
      type: String,
      required: true
    },
    to_pass_params: {
      type: Object,
      default: { }
    }
  },
  created () {
    router.push({ name: this.to_name, params: this.to_pass_params })
  }
}
</script>

<style scoped>
</style>
